module.exports = "pegasus_template/assets/themelp1/large/52.png";